<template>
  <v-sparkline :fill="false" :gradient="gradient" :line-width="2" :padding="8" :smooth="10 || false" :value="data" auto-draw> </v-sparkline>
</template>

<script>
export default {
  name: "AdvancedSparkLine",
  props: {
    data: {
      type: Array,
      required: false,
    },
    gradient: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
